import React, { memo } from 'react';
import cx from 'classnames';

import AddButton from './AddButton';
import Search from './Search';

import Styles from './ListControlPanel.module.scss';
import EntriesPerPage from 'analytics-ui/EntriesPerPage/EntriesPerPage';
import PaginationStatus from 'analytics-ui/PaginationStatus/PaginationStatus';
import Paginate from 'analytics-ui/Paginate/Paginate';

function ListControlPanel({
  dateRangePicker: DateRangePicker,
  withDateRange,
  onSearchChange,
  searchValue,
  withSearch,
  withAddButton,
  withPerPage,
  onAddButtonClick,
  onPerPageChange,
  pagination,
  withPagination,
  onPageChange,
  addButtonText,
  isLoading,
  buttonComponent,
}) {
  const pageCount = Math.ceil(pagination.totalItems / pagination.limit);
  const showPagination = withPagination && pageCount > 1;

  const DefaultButtonComponent = () => (
    <AddButton
      data-testid="AnalyticsSpa-ListControlPanel-CreateButton"
      onClick={onAddButtonClick}
    >
      {addButtonText}
    </AddButton>
  );

  const ButtonComponent = buttonComponent || DefaultButtonComponent;
  return (
    <div
      className={cx(Styles['control-panel'])}
      data-testid="AnalyticsSpa-ListControlPanel-ListControl"
    >
      <div className={Styles['main-block']}>
        <div className={Styles['left-block']}>
          {withPerPage && (
            <EntriesPerPage
              onChange={onPerPageChange}
              value={pagination.limit}
            />
          )}
          {!isLoading && <PaginationStatus pagination={pagination} />}
        </div>

        <div className={Styles['right-block']}>
          {withSearch && (
            <Search onChange={onSearchChange} searchValue={searchValue} />
          )}
          {showPagination && (
            <Paginate
              pageCount={pageCount}
              forcePage={Math.floor(pagination.offset / pagination.limit)}
              onPageChange={onPageChange}
            />
          )}
          {withAddButton && <ButtonComponent />}
          {withDateRange && <DateRangePicker />}
        </div>
      </div>
    </div>
  );
}

export default memo(ListControlPanel);